export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14835.7e05db62.jpg";